import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "shared/customHooks/windowSize";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";

interface PlansPurchasedGridProps {
  activeRole: any;
}

let tabsEnums = {
  parents: 1,
  kids: 2,
  school: 3,
};

function PlansPurchasedGrid({ activeRole }: PlansPurchasedGridProps) {
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [activeTab, setActiveTab] = useState<any>(0);

  let plans = [
    {
      label: "3 Months Plan",
      discounted: false,
      status: 1,
      phone: "030100201211",
      price: "12000",
      coins: "400",
      purchased: 8,
    },
    {
      label: "Monthly Plan",
      discounted: false,
      status: 2,
      phone: "030100322312",
      price: "4000",
      coins: "400",
      purchased: 12,
    },
    {
      label: "6 Months Plan",
      discounted: true,
      status: 3,
      phone: "030100322212",
      price: "24000",
      coins: "400",
      purchased: 20,
    },
    {
      label: "Annual Plan",
      discounted: false,
      status: 1,
      phone: "030100322212",
      price: "48000",
      coins: "400",
      purchased: 19,
    },
    {
      label: "9 Months Plan",
      discounted: false,
      status: 2,
      phone: "030100322212",
      price: "36000",
      coins: "400",
      purchased: 14,
    },
  ];

  const tabs = [
    {
      value: 0,
      label: "Regular Plans",
    },
    {
      value: 1,
      label: "Promotional Plans",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  const planStatus = {
    expired: 1,
    active: 2,
    deactive: 3,
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainTableContainer}>
        <Box className={styles.topHeadingContainer}>
          <div>
            <div className={styles.heading}>
              Most Purchased Plans by{" "}
              {activeRole === tabsEnums.kids
                ? "Kids"
                : activeRole === tabsEnums.parents
                ? "Parents"
                : activeRole === tabsEnums.school
                ? "Schools"
                : ""}{" "}
              Account List
            </div>
            <div className={styles.subHeading}>
              Most Plans purchased by parents, plans are list by most sales{" "}
            </div>
          </div>
          <div className={styles.btnContainer}>
            <button
              className={styles.viewAllBtn}
              onClick={() =>
                navigate(
                  routeConstant.purchasedPlansHistory.path?.replace(
                    ":role",
                    activeRole === tabsEnums.kids
                      ? "kids"
                      : activeRole === tabsEnums.parents
                      ? "parents"
                      : activeRole === tabsEnums.school
                      ? "schools"
                      : ""
                  )
                )
              }
            >
              View All
            </button>
            <button className={styles.filterBtn}>
              <Icons.FilterIcon /> Filter
            </button>
          </div>
        </Box>

        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{
              padding: "0px 14px",
              background: "#f6f9fc",
            }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>
          <div
            style={{ marginTop: "-2px", borderBottom: "1.2px solid #e4e7ec" }}
          />
        </Box>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 330}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Top Plans </TableCell>
                <TableCell>Discounted Plan</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Coins</TableCell>
                <TableCell>Total Purchased</TableCell>
                <TableCell>Total Coins Sold</TableCell>
                <TableCell>Total Money generated</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {plans?.map((item: any, index: number, arr: any[]) => {
                return (
                  <TableRow
                    className={classNames(
                      index + 1 === arr?.length && styles.noBorder
                    )}
                  >
                    <TableCell
                      sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                      className={styles.biggerCell}
                    >
                      <Icons.PlanIcon />
                      <label>{item?.label}</label>
                    </TableCell>
                    <TableCell>{item?.discounted ? "Yes" : "No"}</TableCell>
                    <TableCell>Rs {item?.price}</TableCell>
                    <TableCell>{item?.coins}</TableCell>
                    <TableCell>{item?.purchased} Times</TableCell>
                    <TableCell>
                      {Number(item?.coins) * Number(item?.purchased)}
                    </TableCell>
                    <TableCell className={styles.biggerCell}>
                      Rs. {Number(item?.price) * Number(item?.purchased)}
                    </TableCell>
                    <TableCell className={classNames(styles.statusCell)}>
                      <label
                        className={
                          item?.status === planStatus.active
                            ? styles.approved
                            : item?.status === planStatus.deactive
                            ? styles.rejected
                            : item?.status === planStatus.expired
                            ? styles.neutral
                            : ""
                        }
                      >
                        {item?.status === planStatus.active
                          ? "Active"
                          : item?.status === planStatus.deactive
                          ? "Deactive"
                          : item?.status === planStatus.expired
                          ? "Expired"
                          : ""}
                      </label>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default PlansPurchasedGrid;
